import { render, staticRenderFns } from "./projectActions.vue?vue&type=template&id=519a7abc&"
import script from "./projectActions.vue?vue&type=script&lang=js&"
export * from "./projectActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports